function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Trac\\xE9_1821",
  "data-name": "Trac\\xE9 1821",
  d: "M40.638,3.905a17.219,17.219,0,0,1-4.8,1.318A8.273,8.273,0,0,0,39.5.619a16.707,16.707,0,0,1-5.286,2.016,8.328,8.328,0,0,0-14.406,5.7,8.69,8.69,0,0,0,.19,1.9A23.577,23.577,0,0,1,2.826,1.516,8.331,8.331,0,0,0,5.381,12.652a8.2,8.2,0,0,1-3.762-1.024v.1a8.364,8.364,0,0,0,6.675,8.183,8.432,8.432,0,0,1-2.183.278,7.452,7.452,0,0,1-1.579-.143,8.407,8.407,0,0,0,7.786,5.8A16.762,16.762,0,0,1,1.992,29.4,16.394,16.394,0,0,1,0,29.288a23.443,23.443,0,0,0,12.779,3.738c15.334,0,23.716-12.7,23.716-23.708,0-.365-.016-.722-.032-1.079A16.683,16.683,0,0,0,40.638,3.905Z",
  transform: "translate(0)",
  fill: "#002740"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 40.638,
    height: 33.026,
    viewBox: "0 0 40.638 33.026",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.a6e4e089.svg";
export { ForwardRef as ReactComponent };